import * as angular from 'angular';
import { Decimal } from 'decimal.js';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpMinPriceValidator
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * Validate the minimum price for a price field with {@link pkpBigDecimalConverter} attached.
     *
     * @example
     <div class="input-group" ng-show="!uiCheckPage">
         <input type="text" class="form-control" id="surcharge"
                name="orderPrice{{$index}}"
                ng-model="order.price.value" ng-disabled="order.active"
                pkp-big-decimal-converter pkp-min-price-validator="7">

        <pkp-price-unit price-dto="order.price" possible-units="auction.possibleUnits"
                        is-first="$first" ng-if="order.price">
        </pkp-price-unit>
     </div>

     <ng-messages for="bidForm['orderPrice' + $index].$error"
                  ng-show="bidForm['orderPrice' + $index].$touched || bidForm['orderPrice' + $index].$submitted">
        <p class="help-block" ng-message="pkpMinPriceValidator">
            The surcharge can't be less than 7.
        </p>
     </ng-messages>
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive('pkpMinPriceValidator', pkpMinPriceValidator);

    function pkpMinPriceValidator() {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            ngModelCtrl.$validators.pkpMinPriceValidator = function (
                modelValue
            ) {
                if (
                    !attr.pkpMinPriceValidator ||
                    !modelValue ||
                    ngModelCtrl.$isEmpty(modelValue.value)
                ) {
                    return true;
                }

                try {
                    if (
                        new Decimal(modelValue.value).lessThan(
                            new Decimal(attr.pkpMinPriceValidator)
                        )
                    ) {
                        return false;
                    }
                } catch (e) {
                    return false;
                }

                return true;
            };

            attr.$observe('pkpMinPriceValidator', function () {
                ngModelCtrl.$validate();
            });
        }
    }
})();
